angular.module('dnecom')
    .controller('StoreSetupMobileModalController', ["$scope", "$uibModalInstance", "store", function ($scope, $uibModalInstance, store) {
        $scope.store = angular.copy(store.store || store);

        $scope.activateMobileStore = function () {
            $uibModalInstance.close($scope.store);
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }]);
